module.exports = __webpack_public_path__ + "media/app/assets/races/human_male-abf3d74d829c8e91b08bbbb62aa82426.png";